import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import RateGroup from './rateGroup';
import RateModel from './rateModel';

export default class RatesTreeModel extends BaseAPIModel {
    // Allow us to call getAll directly
    static list(item) {
        return this.fromJSON(item);
    }

    static browseTree(tree) {
        let _tree = [];
        let _rates_list = [];
        tree.forEach(group => {
            if (group.rates) {
                group.rates = group.rates.map(rate => {
                    let _rate = RateModel.fromJSON(rate);
                    _rates_list.push(_rate);
                    return _rate;
                });
            }

            if (group.children) {
                let { tree, rates_list } = this.browseTree(group.children);
                group.children = tree;
                _rates_list = [..._rates_list, ...rates_list];
            }
            _tree.push(RateGroup.fromJSON(group));
        });
        return { tree: _tree, rates_list: _rates_list };
    }

    static fromJSON(tree) {
        let newTree = super.fromJSON(tree);
        //simple array rates list
        newTree.rates_list = [];

        if (newTree.root) {
            let { tree, rates_list } = this.browseTree(newTree.root);
            newTree.root = tree;
            newTree.rates_list = [...newTree.rates_list, ...rates_list];
        }

        if (newTree.rates_without_group) {
            newTree.rates_without_group = newTree.rates_without_group.map(rate => {
                let _rate = RateModel.fromJSON(rate);
                newTree.rates_list.push(_rate);
                return _rate;
            });
        }

        return newTree;
    }

    static listUrl({ organizationId, eventId, ticketsOnly, expand }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][RateTreeModel][getAll] organizationId and eventId are mandatory`);
        }

        const url = `/ticket/organizations/${organizationId}/events/${eventId}/rates_tree`;

        const params = new URLSearchParams();
        if (ticketsOnly) params.append('tickets_only', 'true');
        if (expand) params.append('expand', expand);

        const queryString = params.toString();
        return queryString ? `${url}?${queryString}` : url;
    }

    static rateTreeUpdate(data, { organizationId, eventId }) {
        const url = eventId
            ? `/ticket/organizations/${organizationId}/events/${eventId}/rates_tree/rate_tree_update`
            : `/ticket/organizations/${organizationId}/rates_tree/rate_tree_update`;

        return fetcher.post(url, { data });
    }

    // Iterate over all rates flatly
    eachRate(iteratee, children = null, depth = 0) {
        depth === 0 && this.rates_without_group.forEach(rate => iteratee(rate));
        (depth === 0 ? this.root : children).forEach?.(group => {
            group.rates.forEach?.(rate => iteratee(rate));
            this.eachRate(iteratee, group.children, depth + 1);
        });
    }

    // Iterate over all rates flatly
    eachGroup(iteratee, children = null, depth = 0) {
        (depth === 0 ? this.root : children).forEach?.(group => {
            iteratee(group);
            this.eachGroup(iteratee, group.children, depth + 1);
        });
    }

    // Get the select options object for this tree with groups
    toOptions(options = {}, _groups = null, _depth = 0) {
        const { extraRate, extraGroup, filter = () => true, filterGroup = () => true } = options;
        return [
            ...(_depth === 0 ? this.rates_without_group?.filter?.(filter).map?.(rate => rate.toOption(extraRate)) : []), //this.rates_without_group.map?.(rate => rate.toOption(customRate))),
            ...(_depth === 0 ? this.root : _groups)
                ?.sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))
                .filter?.(filterGroup)
                .map?.(group => ({
                    parent: group.parent, // TODO: verify parent: null is acceptable
                    ...group.toOption(extraGroup),
                    children: [
                        ...group.rates.filter?.(filter).map?.(rate => ({
                            parent: rate.group, // TODO: verify parent: null is acceptable
                            ...rate.toOption(extraRate)
                        })),
                        ...this.toOptions(options, group.children, _depth + 1)
                    ]
                }))
        ];
    }
}
